// 包含生僻字
export const CHINESE = '\u4E00-\u9fa5\uF900-\uFAFF\u3105-\u312D\u3400-\u4DBF'

// 替换eval方法
export const _eval = (str) => {
  let Fn = Function // 一个变量指向Function，防止有些前端编译工具报错
  return new Fn('return ' + str)()
}

// 计算指定字符串的长度，将一个汉字算作两个字符
// const strlen (str) {
//   let s = str.replace(/[^\x00-\xff]/g, "**");
//   return s.length;
// }

/**
 * @description: 计算字符长度
 * @param
 * @return:
 */
export const strlen = (str) => {
  var len = 0
  for (var i = 0; i < str.length; i++) {
    var c = str.charCodeAt(i)
    // 单字节加1
    if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
      len++
    } else {
      len += 2
    }
  }
  return len
}

export const valid = (value, cb, regStr, param, reg) => {
  if (cb === true) {
    let flag = true
    if (reg) {
      flag = reg.test(value)
    }
    if (flag && param && param.length) {
      let len = value.length
      if (param.length === 1) {
        flag = len > param[0]
      } else if (param.length === 2 && (len < param[0] || len > param[1])) {
        flag = len > param[0] && len < param[1]
      }
    }
    return flag
  }
  regStr = regStr || '$t[kui.valid.char]'
  setTimeout(() => {
    if (!value) {
      cb()
    } else {
      if (reg && !reg.test(value) && value !== '') {
        let str = '$t[kui.valid.reg]' + regStr
        cb(str)
      } else if (param && param.length) {
        let len = value.length
        if (param.length === 1 && len < param[0]) {
          let str = '$t[kui.valid.len1]' + regStr
          cb(str, { p1: param[0] })
        } else if (param.length === 2 && (len < param[0] || len > param[1])) {
          let str = '$t[kui.valid.len2]' + regStr
          cb(str, { p1: param[0], p2: param[1] })
        } else {
          cb()
        }
      } else {
        cb()
      }
    }
  }, 100)
}

export const idcardValid = (value, cb, regStr) => {
  let check = (value) => {
    let flag = true
    if (value.length === 18) {
      let idCardWi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2] // 将前17位加权因子保存在数组里
      let idCardY = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2] // 这是除以11后，可能产生的11位余数、验证码，也保存成数组
      let idCardWiSum = 0 // 用来保存前17位各自乖以加权因子后的总和
      for (let i = 0; i < 17; i++) {
        idCardWiSum += Number(value.substring(i, i + 1)) * idCardWi[i]
      }

      let idCardMod = idCardWiSum % 11 // 计算出校验码所在数组的位置
      let idCardLast = value.substring(17) // 得到最后一位身份证号码

      // 如果等于2，则说明校验码是10，身份证号码最后一位应该是X
      if (idCardMod === 2) {
        flag = idCardLast === 'X' || idCardLast === 'x'
      } else {
        // 用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
        flag = Number(idCardLast) === idCardY[idCardMod]
      }
    } else if (value.length === 15) {
      // TODO 15位身份证校验方法
      flag = false
    }
    return flag
  }
  if (cb === true) {
    return check(value)
  }
  setTimeout(() => {
    if (!value) {
      cb()
    } else {
      if (!check(value)) {
        let str = '$t[kui.valid.reg]' + regStr
        cb(str)
      }
    }
  }, 100)
}

// 常用的自定义校验方法
export const valids = {
  // 输入字符串长度校验方法
  length: (value, cb, param) => {
    return valid(value, cb, null, param)
  },
  // 正整数效验
  pInt: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.pInt]', param, /^[1-9]\d*$/)
  },
  // 非正整数效验
  npInt: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.npInt]', param, /^-[1-9]\d*|0$/)
  },
  // 负整数效验
  nInt: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.nInt]', param, /^-[1-9]\d*$/)
  },
  // 非负整数效验
  nNInt: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.nNInt]', param, /^[1-9]\d*|0$/)
  },
  // 整数效验
  int: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.int]', param, /^-?[1-9]\d*$/)
  },
  // 整数范围效验
  intRegion: (value, cb, param) => {
    const reg = new RegExp(`(^[0-9]{${param[0]},${param[1]}}$)|(^[0-9]{${param[0]},${param[1]}}[\.]{1}[0-9]{1,}$)`)
    if (!value) {
      cb()
    } else {
      if (reg && !reg.test(value) && value !== '') {
        let str = '$t[kui.valid.intRegion]'
        cb(str, { p1: param[0], p2: param[1] })
      } else {
        cb()
      }
    }
  },
  // 精度范围效验
  floatRegion: (value, cb, param) => {
    const reg = new RegExp(`(^[0-9]{1,}$)|(^[0-9]{1,}[\.]{1}[0-9]{${param[0]},${param[1]}}$)`)
    if (!value) {
      cb()
    } else {
      if (reg && !reg.test(value) && value !== '') {
        let str = '$t[kui.valid.floatRegion]'
        cb(str, { p1: param[0], p2: param[1] })
      } else {
        cb()
      }
    }
  },
  // 正浮点数效验
  pFNum: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.pFNum]', param, /^[1-9]\d*\.\d*|0\.\d*[1-9]\d*$/)
  },
  // 负浮点数效验
  nFNum: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.nFNum]', param, /^-[1-9]\d*\.\d*|-0\.\d*[1-9]\d*$/)
  },
  // 输入字符串长度校验方法
  num: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.num]', param, /^([\d])+$/)
  },
  num_: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.num_]', param, /^[\d-_]+$/)
  },
  en: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.en]', param, /^[A-Za-z]+$/)
  },
  en_: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.en_]', param, /^[A-Za-z-_]+$/)
  },
  ch: (value, cb, param) => {
    const reg = new RegExp(`^[${CHINESE}]+$`)
    return valid(value, cb, '$t[kui.valid.ch]', param, reg)
  },
  ch_: (value, cb, param) => {
    const reg = new RegExp(`^[${CHINESE}_]+$`)
    return valid(value, cb, '$t[kui.valid.ch_]', param, reg)
  },
  chName: (value, cb, param) => {
    const reg = new RegExp(`^[${CHINESE}·]+$`)
    return valid(value, cb, '$t[kui.valid.ch]', param, reg)
  },
  nch: (value, cb, param) => {
    const reg = new RegExp(`^[^${CHINESE}]+$`)
    return valid(value, cb, '$t[kui.valid.nch]', param, reg)
  },
  nCh: (value, cb, param) => {
    const reg = new RegExp(`^[^${CHINESE}]+$`)
    return valid(value, cb, '$t[kui.valid.nch]', param, reg)
  },
  nAllCh: (value, cb, param) => {
    const reg = new RegExp(`^[^${CHINESE}]+$`)
    return valid(value, cb, '$t[kui.valid.nch]', param, reg)
  },
  numEn: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.numEn]', param, /^[A-Za-z0-9]+$/)
  },
  numEn_: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.numEn_]', param, /^[A-Za-z0-9-_]+$/)
  },
  // 只能输入中文、英文、数字
  chEnNum: (value, cb, param) => {
    const reg = new RegExp(`^([${CHINESE}]|[A-Za-z0-9])+$`)
    return valid(value, cb, '$t[kui.valid.chEnNum]', param, reg)
  },
  chEnNum_: (value, cb, param) => {
    const reg = new RegExp(`^([${CHINESE}]|[A-Za-z0-9-_])+$`)
    return valid(value, cb, '$t[kui.valid.chEnNum_]', param, reg)
  },
  phone: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.phone]', null, /^[1][3,4,5,6,7,8,9][0-9]{9}$/)
  },
  email: (value, cb, param) => {
    return valid(
      value,
      cb,
      '$t[kui.valid.email]',
      null,
      /^[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?$/
    )
  },
  version: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.version]', param, /^[\d+][\.\d+]*$/)
  },
  uri: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.uri]', param, /^[^\u4e00-\u9fa5]+$/)
  },
  datasource: (value, cb, param) => {
    return valid(value, cb, '$t[kui.valid.datasource]', param, /^[^\u4e00-\u9fa5]+$/)
  },
  // 身份证
  idcard: (value, cb, param) => {
    let regStr = '$t[kui.valid.idcard]'
    return idcardValid(value, cb, regStr)
  },
  url: (value, cb, param) => {
    let reg =
      /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return valid(value, cb, '$t[kui.valid.url]', param, reg)
  }
}

export const parserValid = (valid, _locale) => {
  let result = /([a-zA-Z_]+)(.*)/.exec(valid.trim())
  let valRule = valids[result[1]]
  let param = _eval(result[2] || '')
  if (valRule) {
    return (rule, value, cb) => {
      // value 存在时才执行自定义的校验
      if (!value) {
        cb()
      } else {
        valRule(
          value,
          (errStr, obj) => {
            if (errStr) {
              errStr = _locale(errStr, obj)
              cb(new Error(errStr))
            } else {
              cb()
            }
          },
          param
        )
      }
    }
  }
}

export const checkValid = (type, value, param) => {
  let valRule = valids[type]
  if (typeof valRule === 'function') {
    return valRule(value, true, param)
  } else {
    console.error('没有找到指定类型的校验方法')
    return false
  }
}



// WEBPACK FOOTER //
// ./src/components/SimbartUI/utils/valid.js